module.exports = __webpack_public_path__ + "img/boat2.b3b21eed.jpg";